import { render } from "./DialogCanNotChangeAfterDeparture.vue?vue&type=template&id=67e930aa"
import script from "./DialogCanNotChangeAfterDeparture.vue?vue&type=script&lang=js"
export * from "./DialogCanNotChangeAfterDeparture.vue?vue&type=script&lang=js"
script.render = render

export default script